import { el } from './dom.js';

/** 表示モード。scan = スキャンそのまま / simple = 箱で描き直した部屋 / map = 上から見る */
export const DISPLAY_MODES = Object.freeze([
  { id: 'scan', label: 'スキャン' },
  { id: 'simple', label: 'CG' },
  { id: 'map', label: 'マップ' },
]);

/** ツールバーに並べる表示モードの切り替え（3つのうち1つを選ぶ） */
export function createDisplayModeSwitch(container, { initial = 'scan', onChange }) {
  let current = initial;
  const buttons = DISPLAY_MODES.map(({ id, label }) => {
    const button = el('button', { class: 'dm-btn', type: 'button', 'data-mode': id }, label);
    button.addEventListener('click', () => {
      if (id !== current) onChange(id);
    });
    return button;
  });

  const root = el('div', { class: 'dm', role: 'group', 'aria-label': '表示モード' }, buttons);
  const toolbar = container.querySelector('.toolbar');
  (toolbar ?? container).appendChild(root);

  const select = (id) => {
    current = id;
    for (const button of buttons) button.classList.toggle('is-active', button.dataset.mode === id);
  };
  select(initial);

  return {
    select,
    /** 見取りが作れない物件では、シンプル・マップを押せないようにする */
    setSimpleAvailable(available) {
      for (const button of buttons) {
        if (button.dataset.mode !== 'scan') button.disabled = !available;
      }
    },
  };
}
